module.exports = __webpack_public_path__ + "static/media/elements.e0cd830e.png";